import { Task, TaskType, Todo } from '@griply/types';
import {
  addMilliseconds,
  differenceInMilliseconds,
  startOfDay,
} from 'date-fns';

import { HALF_HOUR } from './constants';
import { isNumber } from './is-number';

export const getCalendarTaskStartDate = (task: Task) => {
  // for now, only tasks are allowed to have times
  if ([TaskType.Habit, TaskType.Repeating].includes(task.type)) {
    return;
  }

  // if there is no deadline, startTime or duration, we cannot calculate a start and end
  const todo = task as Todo;
  if (!todo.endStrategy?.deadline || !isNumber(todo.timeslot?.startTime)) {
    return;
  }

  return addMilliseconds(
    startOfDay(todo.endStrategy.deadline),
    todo.timeslot!.startTime,
  );
};

export const getCalendarTaskEndDate = (task: Task) => {
  const startDate = getCalendarTaskStartDate(task);

  // without a startDate we cannot know the endDate
  if (!startDate) {
    return;
  }

  // 30 minutes is the default duration if no duration is set
  return addMilliseconds(startDate, task.timeslot?.duration ?? HALF_HOUR);
};

export const getCalendarTaskStartTime = (date: Date) =>
  differenceInMilliseconds(date, startOfDay(date));

export const getCalendarTaskDuration = (startDate: Date, endDate: Date) =>
  differenceInMilliseconds(endDate, startDate);
